import React from 'react';

const BottomMenu = ({ onPrev, onNext, onToggleHint, onFillHint, showHint, isReviewMode, hideHint, currentIndex = 0, totalCount = 1 }) => (
  <div className="flex items-center justify-between w-full px-6">
    {/* Previous Button */}
    <button
      onClick={onPrev}
      disabled={currentIndex === 0}
      className={`font-headline font-bold flex items-center transition-colors ${
        currentIndex === 0
          ? 'text-gray-300 cursor-not-allowed'
          : 'text-gray-500 hover:text-hupath-scout'
      }`}
    >
      <span className="material-symbols-outlined mr-2">arrow_back</span>
      Trước
    </button>

    {/* Dot Pagination */}
    <div className="flex items-center gap-3">
      {Array.from({ length: totalCount }).map((_, i) => (
        i === currentIndex ? (
          <div key={i} className="w-3 h-3 rounded-full bg-hupath-scout ring-4 ring-hupath-scout/10" />
        ) : (
          <div key={i} className="w-2.5 h-2.5 rounded-full bg-gray-200" />
        )
      ))}
    </div>

    {/* Next Button */}
    <button
      onClick={onNext}
      className="bg-hupath-scout hover:bg-hupath-forest text-white px-8 py-2 rounded-xl font-headline font-bold flex items-center transition-all hover:shadow-lg active:scale-95"
    >
      Tiếp theo
      <span className="material-symbols-outlined ml-2">arrow_forward</span>
    </button>
  </div>
);

export default BottomMenu;
